import { ConfigurationTemplate } from '../wizard-model.interface';
import { Injectable } from '@angular/core';
import { ControlCabinetModel } from './control-cabinet.model';

@Injectable()
export class IoSystemsModel extends ControlCabinetModel {
  public get type() {
    return 'IO_SYSTEMS';
  }

  constructor() {
    super();
  }

  protected createConfig(): ConfigurationTemplate {
    return {
      id: "create-project-io-systems",
      type: 'type',
      imageUrl: "ng-assets/img/projecttypes/io-systems.webp",
      label: "configurationCreation.type.io_systems",
      neededPermission: 'VIEW_IO_ASSISTANT',
      steps: [
        {
          type: "meta",
          id: "meta",
          label: "configurationCreation.progress.configuration_data",
        },
        {
          type: "ioSystems",
          id: "mounting",
          label: 'configurationCreation.progress.mounting_rail',
        }
      ]
    }
  }
}
